import type { LocationIds } from "~/models/Location";

export interface BasicFilters {
  locationIds: LocationIds
  rentMax: number | null
  sizeMin: number | null
  roomsMin: number | null
}

export interface AdditionalFilters {
  housingType: number | null
  housingTypeId: number | null
  housingKind: number | null
  properties: number[]
  housingProperties: number[]
  radius: number | null
  storeyMin: number | null
  storeyMax: number | null
  wgType: string[]
  propertySizeMin: number | null
  requireImages: string
}

export interface Filters extends BasicFilters, AdditionalFilters {}

export function getFiltersQuery(filters: Filters): Record<string, string | null> {
  const o: Record<string, string | null> = {}
  o['locationIds[regions]'] = filters.locationIds.regions.length ? filters.locationIds.regions.join(',') : ''
  o['locationIds[cities]'] = filters.locationIds.cities.length ? filters.locationIds.cities.join(',') : ''
  o['locationIds[areas]'] = filters.locationIds.areas.length ? filters.locationIds.areas.join(',') : ''
  o.rentMax = filters.rentMax ? filters.rentMax.toString() : ''
  o.sizeMin = filters.sizeMin ? filters.sizeMin.toString() : ''
  o.roomsMin = filters.roomsMin ? filters.roomsMin.toFixed(1) : '1'
  o.housingType = filters.housingType ? filters.housingType.toString() : '1'
  o.properties = filters.properties.length ? filters.properties.join(',') : ''
  o.housingProperties = filters.housingProperties.length ? filters.housingProperties.join(',') : ''
  o.radius = filters.radius ? filters.radius.toString() : ''
  o.storeyMin = filters.storeyMin ? filters.storeyMin.toString() : ''
  o.storeyMax = filters.storeyMax ? filters.storeyMax.toString() : ''
  o.propertySizeMin = filters.propertySizeMin ? filters.propertySizeMin.toString() : ''
  o.wgType = filters.wgType && filters.wgType.length ? filters.wgType.join(',') : ''
  o.requireImages = filters.requireImages || '0'
  return o
}

